import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-cta"
    aria-label="Book inspection via WhatsApp"
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full bg-wa py-3.5 pl-4 pr-4 text-white shadow-wa sm:bottom-7 sm:right-7 sm:pr-5"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.95 }}
  >
    <span className="absolute inset-0 -z-10 rounded-full bg-wa animate-pulse-ring" aria-hidden="true" />
    <MessageCircle className="h-6 w-6" />
    <span className="hidden text-sm font-bold sm:block">Book Inspection</span>
  </motion.a>
);
